import React from 'react';
import { Loader, BaasicModal, BaasicConfirmModal, BaasicTable } from 'core/components';
import { LookupEdit, LookupImport } from 'modules/lookup/pages';
import { makePlural } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

class LookupListTemplate extends React.Component {
	render() {
		const { actions, viewStore, t } = this.props;
		const { listStore, tableData, loading, queryUtility, allList, showActions, initDone } = viewStore;
		if ((loading && !viewStore.editModal.isOpen) || !initDone) return <Loader />;
		if (!viewStore.selectedLookup) {
			const { tableData, queryUtility, onRowClick } = this.props;
			return (
				<React.Fragment>
					<div className="layout__main__subheader">
						<h2 className="layout__main__subheader__title">{t('MAINMENU.ADMINISTRATION.LISTS')}</h2>
					</div>
					<BaasicTable
						{...{ queryUtility, tableData, allList, onRowClick, viewStore }}
						data={viewStore.listStore.data.slice()}
					/>
				</React.Fragment>
			);
		} else {
			let itemName = t(viewStore.selectedLookup.parameters.itemName);
			let itemNames = makePlural(itemName);
			return (
				<React.Fragment>
					<div className="layout__main__subheader">
						<h2 className="layout__main__subheader__title">
							{t('MAINMENU.ADMINISTRATION.LOOKUPS', { itemName: _.startCase(itemName) })}
						</h2>
					</div>
					<BaasicTable
						{...{ queryUtility, tableData, viewStore, actions, showActions }}
						data={listStore.data.slice()}
					/>
					<BaasicModal modalParams={viewStore.editModal}>
						<LookupEdit />
					</BaasicModal>
					<BaasicModal modalParams={viewStore.importModal}>
						<LookupImport />
					</BaasicModal>
					<BaasicConfirmModal modalParams={viewStore.deleteConfirmModal} />
				</React.Fragment>
			);
		}
	}
}

export default defaultTemplate(LookupListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/lookup/pages/LookupListTemplate.jsx